import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mailingFields"]
  
  connect() {
    // Check initial state of checkbox on page load
    this.toggleMailingFields()
  }
  
  toggle() {
    const checkbox = this.element.querySelector('input[type="checkbox"]')
    
    if (checkbox.checked) {
      this.copyPhysicalToMailing()
      this.disableMailingFields()
    } else {
      this.enableMailingFields()
    }
  }
  
  toggleMailingFields() {
    const checkbox = this.element.querySelector('input[type="checkbox"]')
    if (checkbox && checkbox.checked) {
      this.disableMailingFields()
    }
  }
  
  copyPhysicalToMailing() {
    // Get physical address values
    const physicalFields = {
      'physical_address_line_1': 'mailing_address_line_1',
      'physical_address_line_2': 'mailing_address_line_2',
      'physical_city': 'mailing_city',
      'physical_state': 'mailing_state',
      'physical_postcode': 'mailing_postcode'
    }
    
    Object.entries(physicalFields).forEach(([physicalName, mailingName]) => {
      const physicalField = document.querySelector(`[name*="[${physicalName}]"]`)
      const mailingField = document.querySelector(`[name*="[${mailingName}]"]`)
      
      if (physicalField && mailingField) {
        mailingField.value = physicalField.value
      }
    })
  }
  
  disableMailingFields() {
    if (!this.hasMailingFieldsTarget) return
    
    const inputs = this.mailingFieldsTarget.querySelectorAll('input, select')
    inputs.forEach(input => {
      input.disabled = true
      input.classList.add('bg-gray-100', 'cursor-not-allowed')
    })
    
    // Add visual indicator that fields are disabled
    this.mailingFieldsTarget.classList.add('opacity-60')
  }
  
  enableMailingFields() {
    if (!this.hasMailingFieldsTarget) return
    
    const inputs = this.mailingFieldsTarget.querySelectorAll('input, select')
    inputs.forEach(input => {
      input.disabled = false
      input.classList.remove('bg-gray-100', 'cursor-not-allowed')
    })
    
    // Remove visual indicator
    this.mailingFieldsTarget.classList.remove('opacity-60')
  }
}
